let hoverOpenCloser: (() => void) | null = null;

let lastHoverCloseAt = 0;

export const getIsTooltipHoverSkipped = (skipDelay: number) => {
    if(skipDelay <= 0) {
        return false;
    }

    if(hoverOpenCloser) {
        return true;
    }

    return lastHoverCloseAt > 0 && Date.now() - lastHoverCloseAt < skipDelay;
};

export const markTooltipHoverOpened = (close: () => void) => {
    const previousCloser = hoverOpenCloser;

    hoverOpenCloser = close;

    if(previousCloser && previousCloser !== close) {
        previousCloser();
    }
};

export const markTooltipHoverClosed = (close: () => void) => {
    if(hoverOpenCloser !== close) {
        return;
    }

    hoverOpenCloser = null;

    lastHoverCloseAt = Date.now();
};
